import { createSvgIcon } from "@mui/material";

const FormatHeading = createSvgIcon(
  <path d="M 16 11 V 4 H 19 V 21 H 16 V 14 H 8 V 21 H 5 V 4 H 8 V 11 H 16 Z"></path>,
  "FormatHeading"
);

export default FormatHeading;
